<template>
    <div @mouseenter="mouseEnter" @mouseleave="mouseLeave" @click.capture="click" :style="{ 'overflow': 'hidden', 'opacity': allowExec ? '1.0' : '0.5' }">
        <div v-if="disabled" class="bg-button-task" style="padding: 10px;">
            Темы доступны только зарегистрированным обучаемым
        </div>
        <div v-if="!disabled" :class="{ 'row cursor-pointer items-center': true, 'text-weight-bold bg-button-task-grey': params.text_bold, 'bg-button-task': !focused && !params.text_bold , 'bg-button-task-focused': focused }">
            <div style="height: 50px; width: 54px; background-color: white; margin: 8px; border-radius: 35px; color: #0378FB" class="flex flex-center">
                <div v-show="!loading" style="color: #0378FB; font-size: 18px;" class="text-weight-bold">{{ number }}</div>
                <div v-show="loading"><q-circular-progress indeterminate color="primary" size="sm" /></div>
            </div>
            <div class="col row items-center" style="height: 70px;">
                <div class="column col" style="padding: 0 5px 0 5px">
                    <div class="ellipsis-2-lines text-weight-bold">{{ title }}</div>
                    <div class="ellipsis" v-show="author !== '[Не указан]'">{{ author }}</div>
                </div>
            </div>
            <div style="width: 40px;" class="row items-center">
                <div style="position: relative; height: 32px; width: 28px;">
                    <q-img v-show="stateEmoji === 'success'" src="~assets/ui/sot-star.svg" />
                    <q-img v-show="stateEmoji === 'skipped'" src="~assets/ui/sot-skipped.svg" />
                    <q-img v-show="stateEmoji === 'bad'" src="~assets/ui/sot-bad.svg" />
                    <q-img v-show="stateEmoji === 'play'" src="~assets/ui/sot-play.svg" />
                    <div v-show="stateEmoji === 'success' && addStars > 1" class="text-caption text-weight-bold text-center" style="position: absolute; top: 5px; left: 1px; z-index: 10; width: 26px">{{ addStars }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';
// import { Humanizer } from 'components/utils/humanText';

export default {
    name: 'ButtonTask',
    mixins: [uiControlMixin],
    props: {
        courseId: {
            type: Number,
            default: undefined,
        },
        disableStart: {
            type: Boolean,
            default: false,
        },
        allowExec: {
            type: Boolean,
            default: true,
        },
        cachedTask: {
            type: Object,
            default: undefined,
        },
        module: {
            type: Object,
            default: undefined,
        },
        taskIndex: {
            type: Number,
            default: undefined,
        },
    },
    mounted () {
        setTimeout(() => {
            this.init();
        }, 100);
    },
    computed: {
        title () {
            return this.task ? this.task.title : undefined;
        },
        author () {
            return this.task ? this.task.author : undefined;
        },
        addStars () {
            if (this.task && this.task.extra_stars) {
                return +this.task.add_stars + +this.task.extra_stars;
            }
            return this.task ? +this.task.add_stars : 0;
        },
    },
    data () {
        return {
            loading: false,
            number: undefined,
            task: undefined,
            completedInfo: undefined,
            focused: false,
            stateEmoji: undefined,
            disabled: false,
        };
    },
    methods: {
        init () {
            const { user } = this.$store.state.pages;
            if (!user) {
                this.disabled = true;
                return;
            }
            this.loading = true;

            const taskId = this.params.task_id;

            if (this.cachedTask) {
                this.task = this.cachedTask;
                this.loading = false;
                this.loadTaskDetails();
                return;
            }

            this.$db.tasks.getTask(taskId).then((task) => {
                this.task = task;
                this.loadTaskDetails();
            });
        },
        loadTaskDetails () {
            const { user } = this.$store.state.pages;
            const { task } = this;
            const { module } = this;
            const { taskIndex } = this;

            if (module && taskIndex !== undefined) {
                if (module.index !== undefined) {
                    this.number = `${module.index + 1}.${taskIndex + 1}`;
                } else {
                    this.number = taskIndex + 1;
                }
            } else if (task.num) {
                // this.number = task.num.toString().padStart(2, '0');
                this.number = (taskIndex + 1).toString().padStart(2, '0');
            }

            this.$db.tasks.getTaskCompleted(task.id, user.chat_id).then((compl) => {
                this.completedInfo = compl;
                if (!compl && task.description) { this.stateEmoji = 'play'; }
                if (compl) {
                    const success = this.task.success_score;
                    if (+compl.score >= +success || success === 0) {
                        if (+task.add_stars > 0) {
                            this.stateEmoji = 'success';
                        }
                    } else {
                        this.stateEmoji = 'bad';
                    }
                    if (compl.is_skipped === '1') {
                        this.stateEmoji = 'skipped';
                    }
                }
                this.$db.users.getUserChatTaskStars(user.chat_id, task.id).then((count) => {
                    if (count && +count > 0) {
                        this.stateEmoji = 'success';
                        this.task.extra_stars = +count;
                    }
                });
            });

            /*
            a22b460aa765
            const starsFromChat = await this.$db.users.getUserChatTaskStars(user.chat_id, taskId);
            if (starsFromChat > 0) {
                this.stateEmoji = 'success';
                this.task.extra_stars = +starsFromChat;
            } else {
            }
            */

            // this.loadExtraStarsFromChat();
            this.loading = false;
        },
        mouseEnter () {
            this.focused = true;
        },
        mouseLeave () {
            this.focused = false;
        },
        async click (e) {
            if (this.disableStart) {
                this.$q.notify('Для начала прохождения курса его нужно купить');
                return;
            }
            if (!this.allowExec) {
                this.$q.notify('Для продолжения выполните предыдущие темы');
                return;
            }

            e.stopPropagation();

            this.$emit('startTask', this.task);
            if (this.$q.platform.is.desktop) {
                this.$router.push({ name: 'quiz', query: { taskId: this.task.id } });
            } else {
                this.$pages.push({ to: 'quiz', params: { task: this.task }, quiz_done_button_visible: this.params.quiz_done_button_visible });
            }

            /*
            e.stopPropagation();
            const { user } = this.$store.state.pages;

            const isSkipped = this.completedInfo && this.completedInfo.is_skipped === '1';
            if (!this.completedInfo || isSkipped) {
                // Если этот this.courseId курс у текущего пользователя не запущен - то запустить его
                // Курс будет запущен после выполнения задания
                // this.$db.tasks.startCourse(this.courseId, user.id);

                if (this.task.extra_stars > 0 && !isSkipped) {
                    const fromDate = '2000-01-01 00:00';
                    const { task } = this;
                    const operatorAnswer = await this.$db.users.getLastUserChatTaskAnswer(user.chat_id, task.id, fromDate);
                    const text = `⭐ Ваш результат по теме: ${this.task.extra_stars} ${Humanizer.getStarsWordCount(this.task.extra_stars)}`;

                    const p1 = {
                        to: 'task',
                        task_id: this.task.id,
                        back_button_visible: '1',
                        quiz_done_button_visible: '0',
                        show_final_text: '1',
                        final_text: text,
                        final_positive: true,
                        operator_answer: operatorAnswer,
                    };
                    if (!this.$q.platform.is.desktop) {
                        this.$pages.push(p1);
                    }
                    this.$emit('startTask', p1);
                } else {
                    // Если задача не выполнена - то перейти к странице задания
                    const showAllTasks = _.get(this.params, 'parent_params.show_all_tasks');
                    const p2 = {
                        to: 'task',
                        task_id: this.task.id,
                        back_button_visible: '1',
                        quiz_done_button_visible: '0',
                        show_all_tasks: showAllTasks,
                        is_skipped: isSkipped ? '1' : '0',
                        final_text: isSkipped ? 'Тема пропущена' : '',
                        show_final_text: isSkipped ? '1' : '0',
                    };
                    if (!this.$q.platform.is.desktop) {
                        this.$pages.push(p2);
                    }
                    this.$emit('startTask', p2);
                }
            } else {
                const { completedInfo } = this;
                const { score } = completedInfo;
                const { task } = this;

                const course = await this.$db.tasks.getUserCourse(user.id, task.course_id);
                if (!course) {
                    console.error(`Ошибка загрузки курса ${task.course_id} для пользователя ${user.id}`);
                    console.log('user:', user);
                    console.log('task:', task);
                    return;
                }

                let operatorAnswer;
                let taskResult = { text: '', positive: true };
                if (+task.add_stars === 0) {
                    taskResult.text = 'Оператор скоро проверит Ваш ответ';
                    const taskStars = await this.$db.users.getUserChatTaskStars(user.chat_id, task.id);
                    if (taskStars > 0) {
                        const tempTask = { ...task };
                        tempTask.add_stars = taskStars;
                        taskResult = Humanizer.getTaskResultText(this, tempTask, user, course, score);
                    }
                    const fromDate = this.completedInfo.created_at;
                    operatorAnswer = await this.$db.users.getLastUserChatTaskAnswer(user.chat_id, task.id, fromDate);
                    if (operatorAnswer && +taskStars === 0) {
                        taskResult = Humanizer.getTaskResultText(this, task, user, course, score);
                        taskResult.positive = false;
                    }
                } else {
                    taskResult = Humanizer.getTaskResultText(this, task, user, course, score, this.task.extra_stars);
                    const fromDate = '2000-10-17 11:00:40';
                    operatorAnswer = await this.$db.users.getLastUserChatTaskAnswer(user.chat_id, task.id, fromDate);
                }

                if (completedInfo.is_skipped === '1') {
                    taskResult.text = 'Тема пропущена';
                }

                const p3 = {
                    to: 'task',
                    task_id: this.task.id,
                    back_button_visible: '1',
                    quiz_done_button_visible: '0',
                    show_final_text: '1',
                    final_text: taskResult.text,
                    final_positive: taskResult.positive,
                    operator_answer: operatorAnswer,
                    is_skipped: completedInfo.is_skipped,
                };
                if (!this.$q.platform.is.desktop) {
                    this.$pages.push(p3);
                }
                this.$emit('startTask', p3);
            }
            */
        },
        /*
        loadExtraStarsFromChat () {
            const { task } = this;
            // if (+task.add_stars > 0) { return; }
            const { user } = this.$store.state.pages;
            this.$db.users.getUserChatTaskStars(user.chat_id, task.id).then((stars) => {
                this.task.extra_stars = +stars;
            });
        },
         */
    },
};
</script>

<style scoped lang="scss">
    .bg-button-task {
        background-color: #E6F1FE;
        color: #323758;
        border-radius: 16px;
    }
    .bg-button-task-grey {
        background-color: #FAC744;
        color: #323758;
        border-radius: 16px;
    }
    .bg-button-task-focused {
        background-color: #75B4FF;
        color: #323758;
        border-radius: 16px;
    }
</style>
